import classNames from "classnames";

export function getDashboardStackGapClassName(isSingleColumnLayout: boolean) {
  return isSingleColumnLayout ? "gap-8" : "gap-6";
}

export function getDashboardColumnsLayoutClassName(isSingleColumnLayout: boolean) {
  return isSingleColumnLayout ? "mt-6 flex flex-col gap-8" : "mt-6 flex flex-row items-start gap-6";
}

export function getDashboardPrimaryColumnClassName(isSingleColumnLayout: boolean) {
  return classNames("flex min-w-0 flex-1 flex-col", getDashboardStackGapClassName(isSingleColumnLayout));
}

export function getDashboardSidebarColumnClassName(isSingleColumnLayout: boolean, hasPrimaryColumn: boolean) {
  return classNames(
    "flex w-full flex-col",
    getDashboardStackGapClassName(isSingleColumnLayout),
    hasPrimaryColumn && !isSingleColumnLayout ? "shrink-0 max-w-sm" : ""
  );
}

export function getDashboardPanelStackClassName(isSingleColumnLayout: boolean) {
  return classNames("flex flex-col", getDashboardStackGapClassName(isSingleColumnLayout));
}
